import { render } from "./CarBadge.vue?vue&type=template&id=0ef29cd4&scoped=true"
import script from "./CarBadge.vue?vue&type=script&lang=js"
export * from "./CarBadge.vue?vue&type=script&lang=js"

import "./CarBadge.vue?vue&type=style&index=0&id=0ef29cd4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef29cd4"]])

export default __exports__